<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="核算备注：">
                <el-input v-model.trim="searchForm.remark" clearable></el-input>
            </el-form-item>
  <el-form-item label="核算时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getPkgListPageHandle">搜索查询</el-button>
               <el-button type="warning" plainicon="el-icon-s-ticket" class="onlyBtn" @click="showBatchChgStateHandler12()">导入核算订单</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >     
            <el-table-column type="index" label="序号" align="center"></el-table-column>  

            <el-table-column prop="totalOrder" label="导入订单数"  align="center"></el-table-column>
            <el-table-column prop="failOrder" label="核算失败数"  align="center"></el-table-column>  
              <el-table-column  align="center"  label="核算成功数">
                 <template v-slot="scope">
                    <p style="color:teal"> {{scope.row.totalOrder -scope.row.failOrder}}</p>
                </template>
            </el-table-column>  
            <el-table-column prop="priceOrder" label="核算明细数"  align="center"></el-table-column >
                <el-table-column prop="totalPrice" label="核算总金额/元"  align="center"></el-table-column>   
                <el-table-column prop="createTime" label="核算时间"  align="center"></el-table-column> 
                  <el-table-column prop="remark" label="核算备注"  align="center"></el-table-column>   
                <el-table-column prop="userName" label="结算人"  align="center"></el-table-column>   
                <el-table-column  align="center"  label="处理状态">
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.state==13|| scope.row.state==16" class="item" effect="dark" :content="scope.row.stateName">
                        <p style="color:#409EFF"> {{scope.row.stateName}}</p>
                    </el-tooltip>
                  <el-tooltip v-else-if="scope.row.state==14" class="item" effect="dark" :content="scope.row.stateName">
                        <p style="color:red"> {{scope.row.stateName}}</p>
                    </el-tooltip>
                    <el-tooltip v-else class="item" effect="dark" :content="scope.row.stateName">
                        <p style="color:teal"> {{scope.row.stateName}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column> 
            <el-table-column label="操作"  width="340px">
                <template v-slot="scope">
                    <el-button   type="primary" plain size="small" @click="goToInfoFailPage(scope.row.id)" >核算明细</el-button>
                       <el-button type="success" plain size="small"  @click="importExces(scope.row.id)"  icon="el-icon-download">导出明细</el-button>
                       <el-button type="danger" v-if="scope.row.state==13" plain size="small"  @click="salePriceToAgents(scope.row.id)"  icon="el-icon-edit">发放佣金</el-button>
                </template>             
            </el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportApplyHandler">确 定</el-button>
            </span>
        </el-dialog>


        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible1"
            width="30%">
            <span>确定要核算佣金吗？ 此操作会直接把佣金发放到代理商账户</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="salePriceToAgent">确 定</el-button>
            </span>
        </el-dialog>
           <el-dialog :append-to-body="true"  title="核算明细" :visible.sync="failVisible" width="1000px" :close-on-click-modal="false" @close="cancel">
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="orderId" label="我方订单号"></el-table-column>
                 <el-table-column prop="agentName" label="代理商"></el-table-column>
                  <el-table-column prop="agentPathName" label="代理商路径"></el-table-column>
                   <el-table-column prop="shopName" label="商品名称"></el-table-column>
                      <el-table-column prop="shopTypeName" label="商品类型"></el-table-column>
                 <el-table-column prop="salePrice" label="发放金额"></el-table-column>
                 <el-table-column prop="stateName" label="核算状态"></el-table-column>
                  <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>



        
          <el-dialog :append-to-body="true"  title="核算订单" :visible.sync="batchOptVisible12" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="addFroms" :model="addFroms"   label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel"> 
                    <el-upload ref="upload" :action="uploadUrl('haoka/import')" :headers="setHeader()" :auto-upload="false" :data="addFroms" :on-change="handleChange" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="downPdf()">导入模板</el-button>
                    </el-upload>
                </el-form-item>
                 <el-form-item label="备注" prop="remark">
                    <el-input v-model="addFroms.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler12">确 定</el-button>
            </div> 
        </el-dialog>        
    </div>
</template>
<script>
import {getPkgListPage, addPkg, updatePkg, getPkgDetail, changePkgState, adminPkgSort,exportSimInfo} from '@/api/package.js'
import common from '@/utils/common.js'
import Clipboard from 'clipboard';
export default {
    data(){     
        return {
            confirmExportDialogVisible:false,
            confirmExportDialogVisible1:false,
             tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            haokaList:[],
            shareImgs:false,
            frontImgUrl:'',
            existBackImg:false,
            addFroms:{
                 remark:''
            },
            searchForm: {
                disposeState: '',
                takePhone: '',
                shopId: '',
                id:'',
                remark:'',
                orderNo:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0,
            },   
            excelId:'',         
            pkgTypeOption: [],
            pkgStateOption: [
                {'code':4,'description':'待处理'},
                {'code':5,'description':'物流派送中'},
                  {'code':6,'description':'已签收-等待首充'},
                    {'code':7,'description':'缺少证件信息'},
                      {'code':8,'description':'审核失败'},
                        {'code':9,'description':'已激活'},
                          {'code':12,'description':'佣金已发放'},
            ],
            pkgStatesOption: [
                {'code':0,'description':'上架'},
                {'code':1,'description':'下架'}
            ],
            agentStateOption: [
                {'code':1,'description':'允许'},
                {'code':2,'description':'不允许'}
            ],
            supplierOption: [],
            addOrEditPkgForm: {
                shopName:'',
                emsCode:'',
                disposeState:'',
                disposeRemark:'',
                newPhone:'',
                orderNo:'',
                account:'',
                pwd: '',
                supplierName: '',
                pwdkey:'',
                supplierShopName:'',
                htmlType:'',
                yongjingInfo:'',
                shopInfo:'',
                pkgType:'',
                agentPrice:'',
                agentPriceParent:''
                         
            },
            unit: 'G',
            currentId: '',
            addFlag: null,
            addPkgVisibale: false,
            pkgGroup: [],
            failVisible:false,
            myPkgGroup: [],
            title: '',
            message:'',
            currentId_fail:'',
            urls:'',
            priceId:'',
            batchOptVisible12:false,
            detailsShow:false,
        }
    },
    methods: {

        salePriceToAgent(){
            var data={
                id:this.priceId
            }
        common.sysRequest('haoka/count/price/sum', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.getPkgListPageHandle();
                    this.confirmExportDialogVisible1=false;
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
         salePriceToAgents(id){
           this.priceId=id;
            this.confirmExportDialogVisible1=true;
        },
         exportApplyHandler(){
            var data = JSON.parse(JSON.stringify(this.searchForm));
            data.id=this.excelId;
            this.exportExcel('/mould/download/countInfos', data);
            this.confirmExportDialogVisible = false;
        },
        importExces(id){
            this.excelId=id;
            this.confirmExportDialogVisible=true;
        },
          showBatchChgStateHandler12(){
            this.batchOptVisible12 = true;
        },
        cancel(){
               this.batchOptVisible12 = false;
            this.shareImgs=false;
            this.addPkgVisibale = false;    
            this.$refs.addOrEditPkgForm.resetFields();  
        },
          downPdf(){
            var link = document.createElement('a');
                link.setAttribute('download', '');
                link.href = '../../../doc/佣金结算模板.xlsx';
                link.click();
        },
        detailsShowChange(){
            this.detailsShow=false
        },
        //直接打开链接
        openLink(){
            window.open(this.urls)
        },
           exportSimInfoHandle(){//导出excel文件
            this.$confirm("您确定要导出订单列表吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {

                 common.deleteSpaceKey(this.searchForm); 
                exportSimInfo(this.searchForm).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err)); 
            })          
        },
        //复制功能
        copy() {
            var clipboard = new Clipboard('.copy_url')
            clipboard.on('success', e => {
              this.$message.success('复制成功');
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message.success('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        //同步上游套餐
        updateUpPkg(){
            common.sysRequest('pkg/update/up/pkg', null, 'get').then(res => {
                if(res.data.code == 200){
                    this.getPkgListPageHandle();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        numberHandle(e){          
            var reg = /^\d+(\.\d{1,2})?/;
            if(reg.exec(e.target.value)) {
                e.target.value = reg.exec(e.target.value)[0];
            }                  
        },
         sureBatchChgStateHandler12(){ 
            this.$refs.addFroms.validate(valid => {
                if(valid) {           
                    this.$refs.upload.submit();
                }
            });

        },
         handleSuccess(res){
            if(res.code == 200){
                this.batchOptVisible12 = false;
                this.getPkgListPageHandle();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
        },
        getPkgListPageHandle($event){   
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
                 common.sysRequest('haoka/count/price/list', data, 'post').then(res => {
                if(res.data.code == 200){
                     common.listCallback(this, res, 'tbpg'); 
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },   
        showAddPkg(){
            this.addPkgVisibale = true;
            this.addFlag = true;
            this.title = '新增商品';
        },
        showEditPkg1(row){
            var data = {
                id: row.id
            }
            common.sysRequest('haoka/share/urls', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.addOrEditPkgForm.shareImg=res.data.data.img;
                    this.shareImgs=true;
                    this.urls=res.data.data.url;
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        showEditPkg11(row){
            var data = {
                id: row.id
            }
            common.sysRequest('haoka/share/addree/urls', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.addOrEditPkgForm.shareImg=res.data.data.img;
                    this.shareImgs=true;
                    this.urls=res.data.data.url;
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        // 点击名称查看详情
        ditailsHeadle(row){
            var data = {
                id: row.id
            }
            this.detailsShow=true;
            common.sysRequest("haoka/share/infos", data, 'post').then(res=>{
                var result = res.data.data;
                for(var key in this.addOrEditPkgForm){
                    this.addOrEditPkgForm[key] = result[key]
                    this.addOrEditPkgForm.state = String(result.state)
                    this.addOrEditPkgForm.htmlType = String(result.htmlType)
                    this.addOrEditPkgForm.pkgType = String(result.pkgType)
                }        
            }).catch(err=> console.error(err));
        },
        showEditPkg(row){
            this.frontImgUrl=true;
            this.addPkgVisibale = true;
            this.addFlag = false;
            this.title = '修改商品';  
            this.currentId = row.id;   
            var data = {
                id: row.id
            }
            this.addOrEditPkgForm.id=row.id;
            this.addOrEidtPkgHandle.shopName=row.shopName;
            this.addOrEidtPkgHandle.newPhone=row.newPhone;
             this.addOrEidtPkgHandle.orderNo=row.orderNo;
              this.addOrEidtPkgHandle.disposeState=row.disposeState;
              this.addOrEidtPkgHandle.emsCode=row.emsCode;
               this.addOrEidtPkgHandle.disposeRemark=row.disposeRemark;
            this.existBackImg=true;
            common.sysRequest("haoka/share/infos", data, 'post').then(res=>{
                var result = res.data.data;
                for(var key in this.addOrEditPkgForm){
                    this.addOrEditPkgForm[key] = result[key]
                }        
            }).catch(err=> console.error(err));
                         
        },
        addOrEidtPkgHandle(){
           common.sysRequest("haoka/update/user", this.addOrEditPkgForm, 'post').then(res=>{
                            if(res.data.code == 200){
                                this.$message.success(res.data.message);
                                this.getPkgListPageHandle();
                                this.addPkgVisibale=false;
                            }else{
                                this.$message.error(res.data.message);
                            }
                        }).catch(err=> console.error(err));
        },
      
        updateSortNo(row){
            //修改排序号
            var data = {
                id: row.id,
                sort: row.sort
            }
            common.sysRequest('app/pc/update/store/sort', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.getPkgListPageHandle();
                }
            })
            
        },
 handleSizeChange(val){
             if(this.failVisible){
             this.tbpg_fail.currentPage = val
            this.goToInfoFailPage(this.currentId_fail);  
           }else{
                 this.tbpg.pageSize = val;
            this.getPkgListPageHandle();
           }   
        },
        handleCurrentChange(val){
            if(this.failVisible){
             this.tbpg_fail.currentPage = val
            this.goToInfoFailPage(this.currentId_fail);  
           }else{
                this.tbpg.currentPage = val;
            this.getPkgListPageHandle();
           }                  
        },

      //失败列表
        goToInfoFailPage(id, $event){
          this.failVisible = true;
            this.currentId_fail = id;
            var data = {
                'id': id
            }
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', data);

           
           common.sysRequest('haoka/count/price/info/list', data, 'post').then(res => {
                if(res.data.code == 200){
                     common.listCallback(this, res, 'tbpg_fail'); 
                }else{
                    this.$message.error(res.data.message);
                }
            })
           
        },
        //选择套餐组
        whenChoosePagGroup(val){
            for(let index in this.pkgGroup){
                if(this.pkgGroup[index].id == val){
                    this.addOrEditPkgForm.supplierType = this.pkgGroup[index].supplierType;
                }
            }
            if(this.addOrEditPkgForm.supplierType == 66){
                common.sysRequest('external/pkg/list', null, 'get').then(res => {
                    if(res.data.code == 200){
                        this.myPkgGroup = res.data.data.map.pkgs;
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }
            
        }

    },
    created () {
         common.gethaokaList(this, 'haokaList');
        this.getPkgListPageHandle();
        
    }  
}
</script>
<style lang="less" scoped>
.input-with-select .el-input {
    width: 60px;
}
.formDialog{
    ::v-deep .el-dialog{
        .el-dialog__body{
            height:500px;
            overflow: auto;
        }
    }
}
</style>

